import { render } from "./match-statistics-basketball.vue?vue&type=template&id=8eac1b14"
import script from "./match-statistics-basketball.vue?vue&type=script&lang=js"
export * from "./match-statistics-basketball.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__